import { render } from "./HeaderUmons.vue?vue&type=template&id=67a40679&scoped=true"
import script from "./HeaderUmons.vue?vue&type=script&lang=js"
export * from "./HeaderUmons.vue?vue&type=script&lang=js"

import "./HeaderUmons.vue?vue&type=style&index=0&id=67a40679&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a40679"]])

export default __exports__